/** Exports pdfmake-wrapper */
export * from './lib/pdfmake-wrapper';
/** Exports document-definition */
export * from './lib/document-definition';
/** Exports the definitions */
export * from './lib/definitions';
/** Exports the interfaces */
export * from './lib/interfaces';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/index.js
// module id = 306
// module chunks = 4